/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    const LOG_TYPE = "Logging";
    const LOG_CATEGORY = "WPT.Logging";
    const DEFAULT_CATEGORY = "*";
    let LogLevelValue;
    (function (LogLevelValue) {
        LogLevelValue[LogLevelValue["OFF"] = 0] = "OFF";
        LogLevelValue[LogLevelValue["FATAL"] = 1] = "FATAL";
        LogLevelValue[LogLevelValue["ERROR"] = 2] = "ERROR";
        LogLevelValue[LogLevelValue["WARN"] = 3] = "WARN";
        LogLevelValue[LogLevelValue["INFO"] = 4] = "INFO";
        LogLevelValue[LogLevelValue["DEBUG"] = 5] = "DEBUG";
        LogLevelValue[LogLevelValue["TRACE"] = 6] = "TRACE";
        LogLevelValue[LogLevelValue["ALL"] = 7] = "ALL";
    })(LogLevelValue || (LogLevelValue = {}));
    class LogManager {
        constructor(core) {
            this._core = null;
            this._logLib = null;
            this._appender = null;
            this._log = null;
            this._config = null;
            this.Type = LOG_TYPE;
            this.getLogger = (category) => {
                
                let logger = this._getLogger(category);
                if (logger.appenders.indexOf(this._appender) < 0) {
                    
                    let level = this._logLib.Level.OFF;
                    if (category === LOG_CATEGORY) {
                        level = this._logLib.Level.ALL;
                    }
                    else {
                        if (this._config === null) {
                            let mainConfig = this._core.Config.getMainConfig();
                            if (mainConfig.hasOwnProperty('Logging') && mainConfig.Logging != null) {
                                this._config = mainConfig.Logging;
                            }
                            else {
                                this._config = {};
                            }
                        }
                        let levelString = this._config[category];
                        if (levelString === null || levelString === undefined) {
                            levelString = this._config[DEFAULT_CATEGORY];
                        }
                        if (levelString !== null && levelString !== undefined) {
                            switch (levelString) {
                                case "ALL":
                                    level = this._logLib.Level.ALL;
                                    break;
                                case "INFO":
                                    level = this._logLib.Level.INFO;
                                    break;
                                case "OFF":
                                default:
                                    level = this._logLib.Level.OFF;
                                    break;
                            }
                        }
                    }
                    logger.setLevel(level);
                    logger.addAppender(this._appender);
                }
                return logger;
            };
            this._initLog4js = () => {
                
                this._logLib = window.Log4js;
                this._initLogging();
            };
            this._getLogger = (category) => {
                
                return this._logLib.getLogger(category);
            };
            this._createAppender = () => {
                
                return new this._logLib.BrowserConsoleAppender();
            };
            this._initLogging = () => {
                
                this._appender = this._createAppender();
                let layout = new this._logLib.PatternLayout('%p %c - %m%n');
                this._appender.setLayout(layout);
                this._log = this.getLogger(LOG_CATEGORY);
                this._log.info("logging initialised");
                // let WPT know that we are ready
                this._core.moduleInitialisationFinished(this);
            };
            
            this._core = core;
            setTimeout(this._initLog4js, 0); // using timeout to allow the core to count the init modules
        }
    }
    WPTNamespace.LogManager = LogManager;
})(WPTNamespace || (WPTNamespace = {}));
